import * as React from 'react';

import CourseraPlusRecommendationsModule from 'bundles/unified-description-page-common/components/recommendations/CourseraPlusRecommendationsModule';
import ExploreMoreCourseRecommendations from 'bundles/unified-description-page-common/components/recommendations/ExploreMoreCourseRecommendations';
import Section from 'bundles/unified-description-page-common/components/shared/Section';
import { useCollections } from 'bundles/unified-description-page-common/contexts/DegreesCollectionsContext';
import { usePageInfo } from 'bundles/unified-description-page-common/contexts/PageInfoContext';
import { useXdpSubscriptionsForwardDiscovery } from 'bundles/unified-description-page-common/providers/SubscriptionsForwardDiscoveryDataProvider';
import type { CollectionEntityFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/CollectionEntityFragment';
import type { ConsumerCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerCoursePageQuery';
import { previewIsUserInXdpAsADiscoveryTool } from 'bundles/unified-description-page-common/utils/xdpAsADiscoveryToolUtils';

type Props = {
  pageData: ConsumerCoursePageFieldsFragment;
};

const ConsumerCourseRecommendationsModuleRenderer = ({ pageData }: Props) => {
  const collections = useCollections();
  const { navigationIdMap } = usePageInfo();
  const { shouldShowXdpChanges } = useXdpSubscriptionsForwardDiscovery();

  if (previewIsUserInXdpAsADiscoveryTool()) {
    return (
      <ExploreMoreCourseRecommendations
        anchorId={navigationIdMap?.RECOMMENDATIONS}
        domainName={pageData.domains?.[0]?.subdomainName || pageData.domains?.[0]?.domainName}
        recommendationsCollection={pageData?.relatedRecommendations as CollectionEntityFragment[]}
        relatedCoursesCollection={pageData?.relatedCourses}
      />
    );
  }

  if (shouldShowXdpChanges) {
    return (
      <Section anchorId={navigationIdMap?.RECOMMENDATIONS}>
        <CourseraPlusRecommendationsModule />
      </Section>
    );
  }

  return (
    <ExploreMoreCourseRecommendations
      anchorId={navigationIdMap?.RECOMMENDATIONS}
      domainName={pageData.domains?.[0]?.subdomainName || pageData.domains?.[0]?.domainName}
      recommendationsCollection={pageData?.relatedRecommendations as CollectionEntityFragment[]}
      relatedCoursesCollection={pageData?.relatedCourses}
      degreesCollection={collections?.degrees}
    />
  );
};

export default ConsumerCourseRecommendationsModuleRenderer;
